import {call, put, takeLatest} from 'redux-saga/effects';
import payoutActions from '../actions/payout.actions';
import PayoutApi from '../api/PayoutApi';
import errorActions from '../actions/error.actions';
import trackingActions, {EVENT_ACTION, EVENT_CATEGORY} from '../actions/tracking.actions';
import alertsActions from '../actions/alerts.actions';

function* setPayoutDate(action) {
    yield put(payoutActions.setPayoutDate(action.payload));
}

function* fetchPayoutReport(action) {
    try {
        const response = yield call(PayoutApi.getPayoutReport, action.payload);
        yield put(payoutActions.getPayoutReportSuccess(response));
    } catch (e) {
        if (e.response && e.response.data) {
            yield put(errorActions.showErrorMessage(e.response.data));
        }
        yield put(payoutActions.getPayoutReportFailed(e));
    }
}

function* fetchPayoutReportList(action) {
    try {
        const response = yield call(PayoutApi.getPayoutReportList, action.payload);
        yield put(payoutActions.getPayoutReportListSuccess(response));
    } catch (err) {
        if (err.response && err.response.data) {
            yield put(errorActions.showErrorMessage(err.response.data));
        }
        yield put(payoutActions.getPayoutReportListSuccess(err));
    }
}

function* fetchPayoutReportDetail(action) {
    try {
        const response = yield call(PayoutApi.getPayoutReportDetail, action.payload);
        yield put(payoutActions.getPayoutReportDetailSuccess(response));
    } catch (err) {
        yield put(payoutActions.getPayoutReportDetailFailed(err));
    }
}

function* traceSecurityLink() {
    try {
        yield call(PayoutApi.traceSecurityLink);
        yield put(
            trackingActions.trackClickEvent(
                EVENT_CATEGORY.TaxIdentity,
                EVENT_ACTION.ClickHyperwalletLink
            )
        );
    } catch (e) {
        console.info('Failed to trace hyper wallet security link ', e);
    }
}

function* getPayoutAcceptance() {
    try {
        const response = yield call(PayoutApi.getPayoutAcceptance);
        yield put(payoutActions.getPayoutAcceptanceSuccess(response));
    } catch (err) {
        yield put(payoutActions.getPayoutAcceptanceFailed(err));
    }
}

function* getPayableAmounts() {
    try {
        const response = yield call(PayoutApi.getPayableAmounts);
        yield put(payoutActions.getPayableAmountsSuccess(response));
    } catch (e) {
        if (e.response && e.response.data) {
            yield put(errorActions.showErrorMessage(e.response.data));
        }
        yield put(payoutActions.getPayableAmountsFailed(e));
    }
}

function* fetchOfflinePayment(action) {
    try {
        const response = yield call(PayoutApi.getOfflinePayment, action.payload);
        yield put(payoutActions.getOffilePaymentSuccess(response));
    } catch (err) {
        if (err.response && err.response.data) {
            yield put(errorActions.showErrorMessage(err.response.data));
        }
        yield put(payoutActions.getOffilePaymentFailed(err));
    }
}

function* saveOfflinePayment(action) {
    try {
        const response = yield call(PayoutApi.saveOfflinePayment, action.payload);
        if (response.data && response.data.accountStatus) {
            yield put(alertsActions.getAlerts());
        }
        yield put(payoutActions.saveOfflinePaymentSuccess(response));
    } catch (err) {
        if (err.response && err.response.data) {
            yield put(errorActions.showErrorMessage(err.response.data));
        }
        yield put(payoutActions.saveOfflinePaymentFailed(err));
    }
}

function* payoutSaga() {
    yield takeLatest(payoutActions.TYPES.SET_PAYOUT_DATE, setPayoutDate);
    yield takeLatest(payoutActions.TYPES.GET_PAYOUT_REPORT, fetchPayoutReport);
    yield takeLatest(payoutActions.TYPES.GET_PAYOUT_REPORT_LIST, fetchPayoutReportList);
    yield takeLatest(payoutActions.TYPES.GET_PAYOUT_REPORT_DETAIL, fetchPayoutReportDetail);
    yield takeLatest(payoutActions.TYPES.TRACE_SECURITY_LINK, traceSecurityLink);
    yield takeLatest(payoutActions.TYPES.GET_PAYOUT_ACCEPTANCE, getPayoutAcceptance);
    yield takeLatest(payoutActions.TYPES.GET_PAYABLE_AMOUNTS, getPayableAmounts);
    yield takeLatest(payoutActions.TYPES.GET_OFFLINE_PAYMENT, fetchOfflinePayment);
    yield takeLatest(payoutActions.TYPES.SAVE_OFFLINE_PAYMENT, saveOfflinePayment);
}

export default payoutSaga;
